import { __BrandDetailLang } from '../brandDetail.lang';

export const __BrandServicesSortList: (lang: typeof __BrandDetailLang) => { title: string; slug: string }[] = (
    lang,
) => [
    { title: lang.mostPriority, slug: 'most_priority' },
    { title: lang.newest, slug: 'newest' },
    { title: lang.oldest, slug: 'oldest' },
    { title: lang.most_visited, slug: 'most_order' },
    { title: lang.most_popular, slug: 'most_favorite' },
];
